let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hXbHP")).then(() => parcelRequire('12gCS'));